import React, { useState, useEffect } from "react";
import { getIncomingPayments } from "../../../services/finance/incomingPayment";
import IncomingPaymentList from "./incomingPayment/incomingPaymentList";
import OutgoingPaymentList from "./outgoingPayment/outgoingPaymentList";
import { PageSubHeader } from "../../../../provider/PageDataProvider";
import DialogLayout from "../../../partials/content/DialogLayout";
import { Card } from "react-bootstrap";
import { useGlobalData } from "../../../../provider/GlobalDataProvider";
function Payment({ match, history }) {
  const { reload } = useGlobalData();
  let openPaymentStream = true;
  let paymentStreamParam = "";
  const urlSplit = match.url.split("/");
  paymentStreamParam = urlSplit[3];
  if (paymentStreamParam === "-") {
    openPaymentStream = true;
  } else {
    openPaymentStream = false;
  }
  const [openPaymentsStream, setOpenPaymentsStream] = useState(
    openPaymentStream
  );
  const [paymentStream, setPaymentStream] = useState(paymentStreamParam);
  const [auth, setAuth] = useState({ create: false });
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
  ];
  if (auth.create) {
    if (paymentStream === "AR") {
      actionButtons.push({
        title: "Switch To A/P",
        color: "label-dark",
        icon: "fas fa-exchange-alt",
        onClick: () => {
          setPaymentStream("AP");
          setOpenPaymentsStream(false);
          history.push("/finance/payments/AP");
        },
      });
      actionButtons.push({
        title: "New A/R Payment",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          history.push("/finance/create-incoming-payment");
        },
      });
    } else if (paymentStream === "AP") {
      actionButtons.push({
        title: "Switch To A/R",
        color: "label-dark",
        icon: "fas fa-exchange-alt",
        onClick: () => {
          setPaymentStream("AR");
          setOpenPaymentsStream(false);
          history.push("/finance/payments/AR");
        },
      });
      actionButtons.push({
        title: "New A/P Payment",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          history.push("/finance/create-outgoing-payment");
        },
      });
    }
  }
  useEffect(() => {
    async function getPaymentData() {
      const response = await getIncomingPayments();
      const { data, auth } = response.data;
      setAuth(auth);
    }
    getPaymentData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={
          paymentStream === "AR"
            ? "Accounts Receivable Payment List"
            : paymentStream === "AP"
            ? "Accounts Payable Payment List"
            : "Payment List"
        }
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: `${
              paymentStream === "AR"
                ? "/finance/payments/AR"
                : paymentStream === "AP"
                ? "/finance/payments/AP"
                : "/finance/payments/-"
            }`,
            title: `${
              paymentStream === "AR"
                ? "A/R Payments"
                : paymentStream === "AP"
                ? "A/P Payments"
                : "Select Payment Stream"
            }`,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      {paymentStream === "AR" ? (
        <IncomingPaymentList history={history} />
      ) : paymentStream === "AP" ? (
        <OutgoingPaymentList history={history} />
      ) : null}
      <DialogLayout
        open={openPaymentsStream}
        title="Select Payment Stream"
        onCloseDialog={() => {}}
        maxWIdth="md"
      >
        <div className="row menu-row-modules mt-4">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setPaymentStream("AR");
                  setOpenPaymentsStream(false);
                  history.push("/finance/payments/AR");
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">
                    Accounts Receivable Payments
                  </div>
                  <i className="fas fa-credit-card fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setPaymentStream("AP");
                  setOpenPaymentsStream(false);
                  history.push("/finance/payments/AP");
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">
                    Accounts Payable Payments
                  </div>
                  <i className="fas fa-money-check-alt fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </DialogLayout>
    </React.Fragment>
  );
}

export default Payment;
